export const defaultIconWidgetOptions = [
  [ "hand-holding-heart", "Anziano"],
  [ "baby", "Fanciullo"],
  [ "child", "Giovane"],
  [ "house-user", "Famiglia"],
  [ "user-graduate", "Studente"],
  [ "users", "Associazione"],
  [ "school", "Istruzione"],
  [ "home", "Abitazione"],
  [ "paw", "Animale domestico"],
  [ "people-arrows", "Integrazione sociale"],
  [ "praying-hands", "Protezione sociale"],
  [ "file-alt", "Programma d'azione"],
  [ "comments", "Comunicazione"],
  [ "landmark", "Edificio urbano"],
  [ "city", "Urbanistica ed edilizia"],
  [ "microscope", "Formazione professionale"],
  [ "chalkboard-teacher", "Acquisizione di conoscenza"],
  [ "hard-hat", "Condizioni e organizzazione del lavoro"],
  [ "bus", "Trasporto"],
  [ "heart", "Matrimonio"],
  [ "person-booth", "Procedura elettorale e voto"],
  [ "theater-masks", "Tempo libero"],
  [ "book", "Cultura"],
  [ "passport", "Immigrazione"],
  [ "smog", "Inquinamento"],
  [ "parking", "Area di parcheggio"],
  [ "traffic-light", "Traffico urbano"],
  [ "water", "Acqua"],
  [ "recycle", "Gestione dei rifiuti"],
  [ "heartbeat", "Salute"],
  [ "user-shield", "Sicurezza pubblica"],
  [ "globe-europe", "Sicurezza internazionale"],
  [ "tree", "Spazio verde"],
  [ "volleyball-ball", "Sport"],
  [ "car", "Trasporto stradale"],
  [ "luggage-cart", "Turismo"],
  [ "plug", "Energia"],
  [ "laptop-code", "Informatica e trattamento dei dati"],
];